import { CURRENCY_CODES as CURRENCY_CODES_CONST } from './constants';

export const isExistCurrencyCode = (currencyCode?: string) => !!currencyCode && !!CURRENCY_CODES[currencyCode];
export const CURRENCY_CODES = CURRENCY_CODES_CONST;
